import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addBodyMapFailure,
  addBodyMapSuccess,
  deleteBodyMapFailure,
  //
  deleteBodyMapSuccess,
  editBodyMapFailure,
  //
  editBodyMapSuccess,
  fetchBodyMapFailure,
  fetchBodyMapSuccess,
  //
  getViewData as getViewDataAction,
  getViewDataFailure,
  getViewDataSuccess,
} from "./actions";
import {
  ADD_BODYMAP,
  DELETE_BODYMAP,
  EDIT_BODYMAP,
  FETCH_BODYMAP,
  GET_VIEW_DATA,
} from "./constants";

export function* fetchBodyMapSaga({
  payload = { cancelToken: null },
  onSuccess,
}) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/resident-body-map?${query}`,
      payload,
    );
    yield put(fetchBodyMapSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(fetchBodyMapFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching body map!"));
  }
}

export function* getViewDataSaga({
  payload = { cancelToken: null },
  onSuccess,
}) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const { data } = yield call(
      api(token).get,
      `/api/resident-body-map/${payload}`,
    );
    yield put(getViewDataSuccess(data));
    typeof onSuccess === "function" && onSuccess(data);
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* addBodyMapSaga({ payload, onAdd }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/resident-body-map/add`,
      payload,
    );
    if (data) {
      yield put(successAlert("Body Map added successfully!"));
      yield put(addBodyMapSuccess());
      typeof onAdd === "function" && onAdd();
    }
  } catch (e) {
    yield put(addBodyMapFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editBodyMapSaga({ payload, onEdit }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/resident-body-map/edit/${payload.id}`,
      payload.data,
    );
    if (data) {
      yield put(successAlert("Body Map updated successfully!"));
      yield put(editBodyMapSuccess());
      typeof onEdit === "function" && onEdit(data);
    }
  } catch (e) {
    yield put(editBodyMapFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteBodyMapSaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);

  try {
    const data = yield call(
      api(token).delete,
      `/api/resident-body-map/${payload?.delete_id}`,
    );
    if (data) {
      yield put(successAlert("Body Map deleted successfully!"));
      yield put(deleteBodyMapSuccess());
      typeof onDelete === "function" && onDelete();
    }
  } catch (e) {
    yield put(deleteBodyMapFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchBodyMapFlow() {
  yield takeEvery(FETCH_BODYMAP, fetchBodyMapSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addBodyMapFlow() {
  yield takeEvery(ADD_BODYMAP, addBodyMapSaga);
}
export function* editBodyMapFlow() {
  yield takeEvery(EDIT_BODYMAP, editBodyMapSaga);
}
export function* deleteBodyMapFlow() {
  yield takeEvery(DELETE_BODYMAP, deleteBodyMapSaga);
}

export default function* ResidentBodyMapSaga() {
  yield all([
    fetchBodyMapFlow(),
    getViewDataFlow(),
    addBodyMapFlow(),
    editBodyMapFlow(),
    deleteBodyMapFlow(),
  ]);
}
